import { sendError } from "lib/sentryHelper";

const PixelHelper = (function () {
  let fbq = null;

  let alreadyEnterSignUp = false;

  const setPixelFunc = () => {
    if (fbq) return true;

    fbq = window.fbq;
    if (!fbq) {
      return false;
    } else {
      return true;
    }
  };

  const isLocalhost = () => {
    return window.location.href.includes("localhost");
  };

  return {
    setPixelEvent: function ({ type }) {
      if (isLocalhost()) return false;
      if (!setPixelFunc()) {
        const errObj = Error("fbq is null");
        sendError(errObj);
        return false;
      }

      switch (type) {
        case "signUp":
          fbq("trackCustom", "CustomSignUp", {
            date: new Date().toISOString()
          });
          return true;
        case "enterSignUp":
          if (alreadyEnterSignUp) return false;
          fbq("trackCustom", "CustomEnterSignUp", {
            date: new Date().toISOString()
          });
          alreadyEnterSignUp = true;
          return true;

        default:
          const errObj = Error("wrong pixel event type");
          errObj.errorValue = { type };
          sendError(errObj);
          return false;
      }
    }
  };
})();

export default PixelHelper;
